import type { City } from "@classes-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { computed } from "vue";
import { type Args, useGetCitiesData } from "./useGetCitiesData.ts";

interface GroupedCityItem {
  label: string;
  value: number;
}

interface GroupedCity {
  label: string;
  code: string;
  items: GroupedCityItem[];
}

export const grouper = (cities?: City[]): GroupedCity[] => {
  if (!cities) return [];

  const grouped = cities.reduce(
    (acc, city) => {
      if (city.country && city.city_ascii && city.id) {
        const countryCode = city.country.iso;
        const countryName = city.country.name;

        if (!acc[countryCode]) {
          acc[countryCode] = {
            label: countryName,
            code: countryCode,
            items: [],
          };
        }

        acc[countryCode].items.push({
          label: city.city_ascii,
          value: city.id,
        });
      }
      return acc;
    },
    {} as Record<string, GroupedCity>,
  );

  return Object.values(grouped).sort((countryA, countryB) => countryA.label.localeCompare(countryB.label));
};

export const useGetGroupedCitiesData = (args: Args) => {
  return useGetCitiesData({
    ...args,
    useQueryOptions: {
      select: grouper,
    },
  });
};
